import { Pipe, PipeTransform } from '@angular/core';
import { FeedbackDto } from '@careapp-group/ng-sdk-v2-new';

@Pipe({
  name: 'feedbackCount',
  pure: true,
})
export class FeedbackCountPipe implements PipeTransform {
  transform(value: FeedbackDto[] = [], rating: number) {
    return value.filter((item) => +item.rating === +rating).length;
  }
}
